import { createFileRoute } from '@tanstack/react-router';
import { createServerFn } from '@tanstack/react-start';
import ContactPage from '../pages/ContactPage';
import { destinationMiddleware } from '../server/middleware/destinationMiddleware';

const loadDestination = createServerFn()
    .middleware([destinationMiddleware])
    .handler(async ({ context }) => {
        return context.destination;
    });

export const Route = createFileRoute('/contact')({
    beforeLoad: async () => {
        try {
            const destination = await loadDestination();
            return { destination };
        } catch (error) {
            console.error('Failed to load destination:', error);
            throw error;
        }
    },
    loader: async ({ context }) => {
        const { destination } = context;
        return { destination };
    },
    // Server-rendered — see routes/index.jsx for why this replaces Helmet.
    head: ({ loaderData }) => {
        const siteUrl = (loaderData?.destination?.url || 'https://www.maasaimara.com').replace(/\/$/, '');
        const canonicalUrl = `${siteUrl}/contact`;
        return {
            meta: [
                { title: 'Wilderness Bookings | Contact Us' },
                {
                    name: 'description',
                    content:
                        'Are you a property owner or a safari operator looking to get direct bookings or just more visibility on the internet? Are you planning your next safari vacation and need credible advice? In either case, feel free to reach out.',
                },
                { property: 'og:title', content: 'Wilderness Bookings | Contact Us' },
                { property: 'og:url', content: canonicalUrl },
            ],
            links: [
                { rel: 'canonical', href: canonicalUrl },
            ],
        };
    },
    component: ContactPage,
    // ── Caching config 
    staleTime: 5 * 60 * 1000,   // reuse cached data for 5 mins on re-navigation
    gcTime: 10 * 60 * 1000,  // keep in memory for 10 mins after route unmounts
});